import CustomTitleAndSubtitle from 'components/CustomTitleAndSubtitle/CustomTitleAndSubtitle';

export default CustomTitleAndSubtitle;
